import {FilterOptionType} from 'commonTypes'
import {createSelector} from 'reselect'
import {AppState} from 'redux/config'

export const select_tabTotals = (state: AppState) => state.totals.tabs
export const select_homeStats = (state: AppState) => state.totals.homeStats
export const select_totals_showFilters = (state: AppState) => state.totals.showFilters
export const select_totals_hydrate = (state: AppState) => state.totals.hydrate

export const select_gridSession = (state: AppState) => state.totals.gridSession
export const select_gridSession_filters = (state: AppState) => state.totals.gridSession.filters
export const select_gridSession_filtersOptions = (state: AppState) => state.totals.gridSession.filterOptions

export const select_renderJobsByStatusChart = createSelector(
  select_homeStats,
  homeStats => !!homeStats.jobStatusCount
)

export const select_jobsByStatus_chartData = createSelector(
  select_homeStats,
  homeStats => homeStats.jobStatusCount
    ? homeStats.jobStatusCount
      .map(record => [record.status, record.count])
    : []
)

export const select_renderJobsByTypeChart = createSelector(
  select_homeStats,
  homeStats => !!homeStats.jobCountByType
)

export const select_jobsByType_chartData = createSelector(
  select_homeStats,
  homeStats => homeStats.jobCountByType
    ? homeStats.jobCountByType
      .map(record => [record.jobType, record.count])
    : []
)

export const select_renderJobsByUrlChart = createSelector(
  select_homeStats,
  homeStats => !!homeStats.jobCountByUrl
)

export const select_jobsByUrl_chartData = createSelector(
  select_homeStats,
  homeStats => homeStats.jobCountByUrl
    ? homeStats.jobCountByUrl
      .map(record => ({
        data: [record.count],
        name: record.label,
      }))
    : []
)

export const select_jobsByUrl_max = createSelector(
  select_homeStats,
  homeStats => homeStats.jobCountByUrl
    ? Math.max(...homeStats.jobCountByUrl.map(record => record.count))
    : 100
)

export const select_renderDatabasesByDatabaseChart = createSelector(
  select_homeStats,
  homeStats => !!homeStats.databaseCountByDatabaseVersion
)

export const select_databasesByDatabaseVersion_chartData = createSelector(
  select_homeStats,
  homeStats => homeStats.databaseCountByDatabaseVersion
    ? homeStats.databaseCountByDatabaseVersion
      .map(record => [record.label, record.count])
    : []
)

export const select_renderDatabasesByAppChart = createSelector(
  select_homeStats,
  homeStats => !!homeStats.databaseCountByAppVersion
)

export const select_databasesByAppVersion_chartData = createSelector(
  select_homeStats,
  homeStats =>
    homeStats.databaseCountByAppVersion
      ? homeStats.databaseCountByAppVersion
        .map(record => [record.label, record.count])
      : []
)

export const select_gridSession_filters_areDirty = createSelector(
  select_gridSession_filters,
  filters => (
    filters.jobStatus.length !== 0 || filters.databaseId.length !== 0
  )
)

export const select_gridSession_filtersOptions_raveUrl = createSelector(
  select_gridSession_filtersOptions,
  filtersOptions => filtersOptions.raveUrl
    .map(database => ({
      value: database.databaseId,
      label: database.hostname,
      subLabel: database.databaseId,
    } as FilterOptionType))
)
